import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useScriptsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/scripts"),

      catalog: () => apiFetch("/scripts/catalog"),

      exportScript: (id) => apiFetch(`/scripts/${id}/export`),

      importScript: (payload) =>
        apiFetch("/scripts/import", { method: "POST", body: JSON.stringify(payload) }),

      create: (data) =>
        apiFetch("/scripts", { method: "POST", body: JSON.stringify(data) }),

      update: (id, data) =>
        apiFetch(`/scripts/${id}`, { method: "PUT", body: JSON.stringify(data) }),

      remove: (id) => apiFetch(`/scripts/${id}`, { method: "DELETE" }),

      checkText: (text) =>
        apiFetch("/scripts/check", { method: "POST", body: JSON.stringify({ text }) }),

      testMatch: (text) =>
        apiFetch("/scripts/test-match", { method: "POST", body: JSON.stringify({ text }) }),

      getConversationState: (conversationId) =>
        apiFetch(`/scripts/conversation/${conversationId}`),

      setConversationBot: (conversationId, payload) =>
        apiFetch(`/scripts/conversation/${conversationId}`, {
          method: "PATCH",
          body: JSON.stringify(payload),
        }),
    }),
    [apiFetch],
  );
}
